<template>
    <el-dialog
            :title="addTextConfig.title"
            :visible.sync="dialogVisible"
            :append-to-body="true"
            :close-on-click-modal="false"
            @close="reset"
            width="700px">

        <el-form :model="form" :rules="rules" ref="form" label-width="120px">
            <el-form-item :label="formTextConfig.examineeName" prop="examineeName">
                <el-input v-model="form.examineeName" :placeholder="formTextConfig.examineeNameTip" maxlength="30" show-word-limit clearable></el-input>
            </el-form-item>
            <el-form-item :label="formTextConfig.admissionNo" prop="admissionNo">
                <el-input v-model="form.admissionNo"  :placeholder="formTextConfig.admissionNoTip" maxlength="30" show-word-limit clearable></el-input>
                <span>{{formTextConfig.tip}}</span>
            </el-form-item>
            <el-form-item :label="formTextConfig.examineeIdcard" prop="examineeIdcard">
                <el-input v-model="form.examineeIdcard" :placeholder="formTextConfig.examineeIdcardTip" maxlength="18" show-word-limit clearable></el-input>
                <span>{{formTextConfig.tip}}</span>
            </el-form-item>
            <el-form-item :label="formTextConfig.pilotSchool">
                <el-input v-model="form.pilotSchool"  :placeholder="formTextConfig.pilotSchoolTip" maxlength="100" show-word-limit clearable></el-input>
            </el-form-item>
            <el-form-item :label="formTextConfig.assessmentSite">
                <el-input v-model="form.assessmentSite" :placeholder="formTextConfig.assessmentSiteTip" maxlength="100" show-word-limit clearable></el-input>
            </el-form-item>
            <el-form-item :label="formTextConfig.centreName">
                <el-input v-model="form.centreName"  :placeholder="formTextConfig.centreNameTip" maxlength="100" show-word-limit clearable></el-input>
            </el-form-item>
            <el-form-item :label="formTextConfig.seatNo" prop="seatNo">
                <el-input v-model="form.seatNo"  :placeholder="formTextConfig.seatNoTip" maxlength="10" show-word-limit clearable></el-input>
                <span>{{formTextConfig.tip}}</span>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{ formTextConfig.button.cancel }}</el-button>
            <el-button type="primary" @click="addExaminee">{{ formTextConfig.button.ok }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import {addExaminee} from "@/api/arrangement";

    export default {
        props: ['examId'],
        computed: {
            addTextConfig() {
                return this.$store.state.global.textConfig.backend.arrangement.examEdit.examinee.add
            },
            formTextConfig() {
                return this.addTextConfig.form
            },
        },
        data() {
            return {
                dialogVisible: false,
                form: {
                    examineeName: null,
                    admissionNo: null,
                    examineeIdcard: null,
                    pilotSchool: null,
                    assessmentSite: null,
                    centreName: null,
                    seatNo: null
                },
                rules: {
                    examineeName: [
                        {required: true, max: 30, message: '选手姓名不可为空', trigger: 'blur'},
                        {max: 30, message: '选手姓名长度最大为30个字符', trigger: 'blur'}
                    ],
                    admissionNo: [
                        {required: true, message: "选手参赛编号不可为空", trigger: "blur"},
                        {min: 6, max: 30, message: '选手参赛编号长度值6~30个字符之间', trigger: 'blur'},
                        {
                            validator: function (rule, value, callback) {
                                if (/^[a-zA-Z0-9]*$/.test(value) === false && value) {
                                    callback(new Error("仅支持输入大小写字母和数字"))
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'blur',
                        },
                    ],
                    examineeIdcard:[
                        {
                            validator: function (rule, value, callback) {
                                if (/^[a-zA-Z0-9]*$/.test(value) === false && value) {
                                    callback(new Error("仅支持输入大小写字母和数字"))
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'blur',
                        },
                    ],
                    seatNo:[
                        {
                            validator: function (rule, value, callback) {
                                if (/^[a-zA-Z0-9]*$/.test(value) === false && value) {
                                    callback(new Error("仅支持输入大小写字母和数字"))
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'blur',
                        },
                    ],


                }
            }
        },

        methods: {
            open() {
                this.dialogVisible = true
            },
            addExaminee() {
                this.$refs.form.validate(vaild => {
                    if (vaild) {
                        addExaminee(this.examId, this.form).then(res => {
                            if (res.status === 200) {
                                this.$message.success('添加选手成功')
                                this.dialogVisible = false
                                this.$emit('success')
                            }
                        })
                    }
                })
            },
            reset() {
                this.form = {
                    username: null,
                    realname: null,
                    phone: null,
                    email: null,
                    password: null,
                    confirmPwd: null
                }
                this.$refs.form.resetFields()
            }
        }
    }
</script>

<style scoped>

</style>
